// extracted by mini-css-extract-plugin
export default {"wrapper":"widget_wrapper__RSqmu","actions":"widget_actions__zc-ia","trashIcon":"widget_trashIcon__r3ESl"};